











import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import StaggeringTransitionGroup from './staggering-transition-group.vue';

@Component({
  components: {
    StaggeringTransitionGroup
  }
})
export default class DefaultGrid extends Vue {
  @Prop({ default: 6 })
  private columns: number;
  @Prop({ default: 50 })
  private stagger: number;
  @Prop({ default: true })
  private animationsDelayEnabled: boolean;

  get gridColumnsClass(): string {
    return this.columns ? `ebx-grid--cols-${ this.columns }` : '';
  }

}
